/* On document ready */
jQuery(document).ready(function($) { 


  /* **************************************************  */
  /* VAR */
  /* **************************************************  */
 
  var  h_header = 42;
  var LARGEUR_MAX_MOBILE = 1024;
  var header = $("#masthead");
  var l_window = parseInt($(window).width());
  var TitleAtelier = $('.TitleAtelier');
  var NameAtelier = $('#name_atelier');

   


   /* *****************  */
    /* FEATHERLIGHT / INSCPRIPTION ATELIER */
  /* *****************  */
  $('a.link_featherlight_atelier-js').featherlight(
    $("#block_form_atelier"),
    {
    type : "html",
    otherClose : 'span.icon-close',
    beforeOpen:function(event){
      console.log(event);
      var title_atelier = $(event.currentTarget).attr('data-title');
     // console.log("ici " + $('#TitleAtelier').text());
      TitleAtelier.text(title_atelier);
      NameAtelier.val(title_atelier);

       // console.log($('this').attr('data-title')); // this contains all related elements
       // return false; // prevent lightbox from opening
      }
  });

  /* *****************  */
    /* FEATHERLIGHT / INSCPRIPTION NEWSLETTER */
  /* *****************  */
  $('a.link_featherlight').featherlight(
    $("#block_newsletter"),
    {
    type : "html",
    otherClose : 'span.icon-close',
  });


   /* **************************************************  */
  /* GALERY LIGHTBOX */
  /* **************************************************  */


  $('.gallery').featherlightGallery();
  $('.gallery2').featherlightGallery();

  var $NextElt = $("#gallery_more"); 
  if ( $NextElt.length ) {
    $NextElt.hide();
  }
  
  $( ".action-js-btn-more" ).click(function(e) {

    if($NextElt.hasClass('open')){
        $NextElt.slideUp(500, function(){
          $NextElt.removeClass('open');
        });
    }else{
        $NextElt.slideDown(500, function(){
          $NextElt.addClass('open');
        });
    }

    e.preventDefault();
  });

  /* **************************************************  */
  /* HOVER SUR MAISON */
  /* **************************************************  */


  var dest_class = '';
  $( ".point" ).hover(
  function(e) {
    dest_class = $(this).attr('data-dest');
    $('#svg_maison_hover '+ '.'+dest_class).addClass('over');
  }, function(e) {
    $('#svg_maison_hover '+ '.'+dest_class).removeClass('over');
  }
);

   /* **************************************************  */
  /* ANIMATION AU SCROLL */
  /* **************************************************  */
 

  /* ANIMATION : LES ESCALIERS */

  /* On lance quand meme l'animation du début */
  if(l_window > LARGEUR_MAX_MOBILE){
  var y_scroll = window.scrollY;
  if(y_scroll == 0){
    $('.SpecialFirst').addClass('inview');
    $('body').addClass('to_m_smenu');
  }

  $('.Stair').bind('inview',function(event, isInView, visiblePartX, visiblePartY){
       if (isInView) {
              $(this).parent().addClass('inview');
      }else{
              $(this).parent().removeClass('inview');
      }
  });
}

 $(window).scroll(function () {
    action_on_scroll();
  });

  function action_on_scroll(){

    l_window = parseInt($(window).width());
   

    if (l_window > LARGEUR_MAX_MOBILE){
       if ($(window).scrollTop() > h_header - 30){
        header.addClass("Masthead--sticky");
        $("body").addClass('header--sticky');
        }else{
              header.removeClass("Masthead--sticky");
            $("body").removeClass('header--sticky');
        }
    }  
 }



   /* **************************************************  */
  /* NICSELECT */
  /* **************************************************  */
 
  $('.to_nicedropdown-js').niceSelect();


   /* **************************************************  */
  /* DATEPICKER */
  /* **************************************************  */
  // https://github.com/fengyuanchen/datepicker
  $('[data-toggle="datepicker"]').datepicker({
    language: 'fr-FR'
  });

  // TO REMOVE...
  // $('input[type=radio][name=projet_type]').change(function() {});

   /* **************************************************  */
  /* LABEL - TO MOVE */
  /* **************************************************  */

    // Formulaire de contact ///
   $( ".for_m_label input,.for_m_label textarea " ).click(function() {
      $( this ).parent().addClass('focus');
  });

    $( ".for_m_label label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".for_m_label input,.for_m_label textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".for_m_label input,.for_m_label textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().addClass('focus');
  });

   $('.for_m_label input,.for_m_label textarea').on('blur input', function() {
   if($(this).val() != '') $( this ).parent().addClass('focus');
});




  /* *****************  */
    /*  AJAX - RECAPTCHA FORM ATELIER*/
  /* *****************  */


  //this submit part need to be move to the recaptacha validation script after succeed.

  var ToDisplayMessage_atelier = $('#message_form_atelier');
  ToDisplayMessage_atelier.hide();
  var IdFormMessage =  $('#form_atelier_token');

  $('.FormAtelier').submit(function(e) {
    e.preventDefault();
    
    var This_new_form = $(this);

    This_new_form.addClass('form__to_load');

    var action_this_form = 'form_atelier_augusterie';

      grecaptcha.execute('6Ld94sUUAAAAALkXd5tYwixONcSQfjRchGtajinw', {action: action_this_form}).then(function(token) {
      document.getElementById('form_atelier_token').value=token;
      var formData = This_new_form.serialize();
     
        // AJAX POUR VERIFIER LE CAPTCHA //
         $.ajax({
              url : ajaxurl,
              method : 'POST',
              data : {
                'action' : 'atelier_ajax_form',
                form_data : formData,
                security: $('#security_atelier_form').val()
            }
          }).done(function(response) {
           
            $('#nom_atelier, #prenom_atelier, #email_atelier, #nb_entree_atelier, #message_atelier').val("");
            This_new_form.removeClass('form__to_load');
            ToDisplayMessage_atelier.removeClass('error').addClass('success');
            ToDisplayMessage_atelier.slideDown(300);
            ToDisplayMessage_atelier.html('<p><strong>Votre demande a bien été enregistrée.</strong></p><p>'+response+'</p>');


        }).fail(function(data) {
         /// ICI, PAS LE BON CAPTCHA OU PROBLEME DE FORMULAIRE
          This_new_form.removeClass('form__to_load');
        // console.log('PB DE FORMULAIRE');
        // console.log(data.responseText);
         ToDisplayMessage_atelier.removeClass('success').addClass('error');
         ToDisplayMessage_atelier.slideDown(300);
         ToDisplayMessage_atelier.html('<p><strong>Erreur de validation</strong></p><p>'+data.responseText+'</p>');


      });

    }, function (reason) {
      // ICI LE CAPTCHA QUI VEUT PAS S'EXECUTER
        This_new_form.removeClass('form__to_load');
        ToDisplayMessage_atelier.removeClass('success').addClass('error');
        ToDisplayMessage_atelier.slideDown(300);
        ToDisplayMessage_atelier.html('<p><strong>Erreur de validation</strong></p><p>'+reason+'</p>');
        console.log(reason);

   });


    });




  /* *****************  */
    /*  CONTACT PAGE AJAX - RECAPTCHA FORM NEWSLETTER INNER CONTACT PAGE*/
  /* *****************  */


  //this submit part need to be move to the recaptacha validation script after succeed.

  var ToDisplayMessage_news__innerpage = $('#message_form_newsletter_inpage');
  ToDisplayMessage_news__innerpage.hide();

  $('.FormNewsletter_inpage').submit(function(e) {
    e.preventDefault();
    
    var This_new_form = $(this);

    This_new_form.addClass('form__to_load');

    var action_this_form = 'form_newsletter_augusterie_inpage';

      grecaptcha.execute('6Ld94sUUAAAAALkXd5tYwixONcSQfjRchGtajinw', {action: action_this_form}).then(function(token) {
      document.getElementById('form_newsletter_token_inpage').value=token;
      var formData = This_new_form.serialize();
     
        // AJAX POUR VERIFIER LE CAPTCHA //
         $.ajax({
              url : ajaxurl,
              method : 'POST',
              data : {
                'action' : 'newsletter_ajax_form_inpage',
                form_data : formData,
                security: $('#security_newsletter_form_inpage').val()
            }
          }).done(function(response) {
           
            $('#nom_newsletter_inpage, #prenom_newsletter_inpage, #email_newsletter_inpage').val("");
            This_new_form.removeClass('form__to_load');
            ToDisplayMessage_news__innerpage.removeClass('error').addClass('success');
            ToDisplayMessage_news__innerpage.slideDown(300);
            ToDisplayMessage_news__innerpage.html('<p><strong>Bienvenue à bord !</strong></p><p>'+response+'</p>');


        }).fail(function(data) {
         /// ICI, PAS LE BON CAPTCHA OU PROBLEME DE FORMULAIRE
          This_new_form.removeClass('form__to_load');
        // console.log('PB DE FORMULAIRE');
        // console.log(data.responseText);
         ToDisplayMessage_news__innerpage.removeClass('success').addClass('error');
         ToDisplayMessage_news__innerpage.slideDown(300);
         ToDisplayMessage_news__innerpage.html('<p><strong>Erreur de validation</strong></p><p>'+data.responseText+'</p>');


      });

    }, function (reason) {
      // ICI LE CAPTCHA QUI VEUT PAS S'EXECUTER
        This_new_form.removeClass('form__to_load');
        ToDisplayMessage_news__innerpage.removeClass('success').addClass('error');
        ToDisplayMessage_news__innerpage.slideDown(300);
        ToDisplayMessage_news__innerpage.html('<p><strong>Erreur de validation</strong></p><p>'+reason+'</p>');
        console.log(reason);

   });


    });




  /* *****************  */
    /*  AJAX - RECAPTCHA FORM NEWSLETTER*/
  /* *****************  */


  //this submit part need to be move to the recaptacha validation script after succeed.

  var ToDisplayMessage_news = $('#message_form_newsletter');
  ToDisplayMessage_news.hide();

  $('.FormNewsletter').submit(function(e) {
    e.preventDefault();
    
    var This_new_form = $(this);

    This_new_form.addClass('form__to_load');

    var action_this_form = 'form_newsletter_augusterie';

      grecaptcha.execute('6Ld94sUUAAAAALkXd5tYwixONcSQfjRchGtajinw', {action: action_this_form}).then(function(token) {
      document.getElementById('form_newsletter_token').value=token;
      var formData = This_new_form.serialize();
     
        // AJAX POUR VERIFIER LE CAPTCHA //
         $.ajax({
              url : ajaxurl,
              method : 'POST',
              data : {
                'action' : 'newsletter_ajax_form',
                form_data : formData,
                security: $('#security_newsletter_form').val()
            }
          }).done(function(response) {
           
            $('#nom_newsletter, #prenom_newsletter, #email_newsletter').val("");
            This_new_form.removeClass('form__to_load');
            ToDisplayMessage_news.removeClass('error').addClass('success');
            ToDisplayMessage_news.slideDown(300);
            ToDisplayMessage_news.html('<p><strong>Bienvenue à bord !</strong></p><p>'+response+'</p>');


        }).fail(function(data) {
         /// ICI, PAS LE BON CAPTCHA OU PROBLEME DE FORMULAIRE
          This_new_form.removeClass('form__to_load');
        // console.log('PB DE FORMULAIRE');
        // console.log(data.responseText);
         ToDisplayMessage_news.removeClass('success').addClass('error');
         ToDisplayMessage_news.slideDown(300);
         ToDisplayMessage_news.html('<p><strong>Erreur de validation</strong></p><p>'+data.responseText+'</p>');


      });

    }, function (reason) {
      // ICI LE CAPTCHA QUI VEUT PAS S'EXECUTER
        This_new_form.removeClass('form__to_load');
        ToDisplayMessage_news.removeClass('success').addClass('error');
        ToDisplayMessage_news.slideDown(300);
        ToDisplayMessage_news.html('<p><strong>Erreur de validation</strong></p><p>'+reason+'</p>');
        console.log(reason);

   });


    });


  /* *****************  */
    /*  AJAX - RECAPTCHA FORM - EVENT */
  /* *****************  */


  //this submit part need to be move to the recaptacha validation script after succeed.

  var ToDisplayMessage = $('#message_form_event');
  ToDisplayMessage.hide();

  $('.FormProject').submit(function(e) {
    e.preventDefault();
    
    var This_new_form = $(this);

    This_new_form.addClass('form__to_load');

    var action_this_form = 'form_event_augusterie';

      grecaptcha.execute('6Ld94sUUAAAAALkXd5tYwixONcSQfjRchGtajinw', {action: action_this_form}).then(function(token) {
      document.getElementById('form_event_token').value=token;
      var formData = This_new_form.serialize();
     
        // AJAX POUR VERIFIER LE CAPTCHA //
         $.ajax({
              url : ajaxurl,
              method : 'POST',
              data : {
                'action' : 'event_ajax_form',
                form_data : formData,
                security: $('#security_event_form').val()
            }
          }).done(function(response) {
           
            This_new_form.removeClass('form__to_load');
            ToDisplayMessage.removeClass('error').addClass('success');
            ToDisplayMessage.slideDown(300);
            ToDisplayMessage.html('<p><strong>Demande envoyée !</strong></p><p>'+response+'</p>');


        }).fail(function(data) {
         /// ICI, PAS LE BON CAPTCHA OU PROBLEME DE FORMULAIRE
          This_new_form.removeClass('form__to_load');
        // console.log('PB DE FORMULAIRE');
        // console.log(data.responseText);
         ToDisplayMessage.removeClass('success').addClass('error');
         ToDisplayMessage.slideDown(300);
         ToDisplayMessage.html('<p><strong>Erreur de validation</strong></p><p>'+data.responseText+'</p>');


      });

    }, function (reason) {
      // ICI LE CAPTCHA QUI VEUT PAS S'EXECUTER
        This_new_form.removeClass('form__to_load');
        ToDisplayMessage.removeClass('success').addClass('error');
        ToDisplayMessage.slideDown(300);
        ToDisplayMessage.html('<p><strong>Erreur de validation</strong></p><p>'+reason+'</p>');
        console.log(reason);

   });


    });




   /* **************************************************  */
  /* MENU TOGLE PRINCIPAL*/
  /* **************************************************  */
 
  $("#primary-menu ul.sub-menu").hide();

  $("#primary-menu > li#menu-item-45 > a,#primary-menu > li#menu-item-48 > a,#primary-menu > li#menu-item-44 > a").each( function () {
        $(this).replaceWith('<a class="to_open_sub_menu" href="" title="Afficher le sous-menu">' + $(this).text() + '<\/a>') ;
    } ) ;


  /// On modifie l'évènement "click" sur les liens dans les items de liste
    // qui portent la classe "toggleSubMenu" :
    $("#primary-menu > li > a.to_open_sub_menu").click( function () {
        // Si le sous-menu était déjà ouvert, on le referme :
        if ($(this).next("ul.sub-menu:visible").length != 0) {
            $(this).next("ul.sub-menu").slideUp("normal");
            $(this).parent().removeClass("open");
        }
        // Si le sous-menu est caché, on ferme les autres et on l'affiche :
        else {
            $("#primary-menu ul.sub-menu").parent().removeClass('open');
            $("#primary-menu ul.sub-menu").slideUp("normal");
            $(this).next("ul.sub-menu").slideDown("normal");
            $(this).parent().addClass("open");
        }
        // On empêche le navigateur de suivre le lien :
        return false;
    });


  var popup_already_display = sessionStorage.getItem('popState');
 // popup_already_display = 'test';

  if(popup_already_display != 'shown'){// shown

    if ( $( ".lightbox_popup_event--link" ).length ) {


    $('a.lightbox_popup_event--link').featherlight(
      $("#popup_event"),
      {
      type : "html",
      otherClose : 'span.icon-close',
      afterOpen:function(event){
        console.log(event);
        sessionStorage.setItem('popState','shown');
        }
    }).click();



    }
  }






});